import { Injectable } from '@angular/core';
import { HttpClient} from '@angular/common/http';
import { Observable  } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

import { AppConfig } from '@solar/app.config';
import { User } from 'solar-bo';
import { ErrorcontrolService } from 'basecomponents';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  private apiUrl = AppConfig.API_ENDPOINT+'/users';  // URL to web api
  constructor(  private http: HttpClient
    ,private errorcontrolservice: ErrorcontrolService){}



  getUsers (): Observable<User[]> {  
    let u=this.apiUrl;
      return this.http.get<any[]>(u)
      .pipe(
        tap(_ => this.errorcontrolservice.log(`fetched users correctly`))
        ,catchError(this.errorcontrolservice.handleError('getUsers', []))
      ); 
  }

/*   siteGetZones(id: string): Observable<Zone[]> {
    const url = `${this.apiurlbase}/sites/${id}/zones`;
    return this.http.get<any[]>(url).pipe(
        tap(_ => this.errorcontrolservice.log(`fetched siteGetZones id=${id}`)),
        catchError(this.errorcontrolservice.handleError<any>(`siteGetZones id=${id}`))
    );
} */

  getUser(id: string): Observable<User> {
    this.errorcontrolservice.log(`getUser called id=${id}`);
    const url = `${this.apiUrl}/${id}`;
    return this.http.get<User>(url,AppConfig.httpOptions).pipe(
      tap(_ => this.errorcontrolservice.log(`fetched User id=${id}`)),
      catchError(this.errorcontrolservice.handleError<User>(`getUser id=${id}`))
    );
  }
  //////// Save methods //////////
  /** POST: add a new user to the server */
  addUser (user: User): Observable<User> {
    return this.http.post<User>(this.apiUrl, user, AppConfig.httpOptions).pipe(
      tap((user: User) => this.errorcontrolservice.log(`added user w/ id=${user.id}`)),
      catchError(this.errorcontrolservice.handleError<User>('addUser'))
    );
  }

  /** DELETE: delete the user from the server */
  deleteUser (user: User | number): Observable<User> {
    const id = typeof user === 'number' ? user : user.id;
    const url = `${this.apiUrl}/${id}`;

    return this.http.delete<User>(url, AppConfig.httpOptions).pipe(
      tap(_ => this.errorcontrolservice.log(`deleted user id=${id}`)),
      catchError(this.errorcontrolservice.handleError<User>('deleteUser'))
    );
  }
  /** PUT: update the user on the server */
  updateUser (user: User): Observable<any> {
    const id = typeof user === 'number' ? user : user.id;
    const url = `${this.apiUrl}/${id}`;

    return this.http.post<User>(this.apiUrl, user, AppConfig.httpOptions).pipe(
      tap((user: User) => this.errorcontrolservice.log(`added user w/ id=${user.id}`)),
      catchError(this.errorcontrolservice.handleError<User>('addUser'))
    );
  }

  updatepch (user: User): Observable<any> {
    const id = typeof user === 'number' ? user : user.id;
    const url = `${this.apiUrl}/pch/${id}`;
    return this.http.put(url, user, AppConfig.httpOptions).pipe(
      tap(_ => this.errorcontrolservice.log(`updated user id=${user.id}`)),
      catchError(this.errorcontrolservice.handleError<any>('updateUser'))
    );
  }


  updateUserRole (userid:string, role:any): Observable<any> {
    const id = userid;
    const url = `${this.apiUrl}/setrole/${id}`;

    return this.http.put(url, role, AppConfig.httpOptions).pipe(
      tap(_ => this.errorcontrolservice.log(`updateUserRole user role id=${userid}`)),
      catchError(this.errorcontrolservice.handleError<any>('updateUserRole'))
    );
  }

}


/*
Copyright 2017-2018 Google Inc. All Rights Reserved.
Use of this source code is governed by an MIT-style license that
can be found in the LICENSE file at http://angular.io/license
*/
